let translationsAADAT = {
	gasCirco: 'Gáz - Cirko',
	gasConvector: 'Gáz - Konvektor',
	gasHera: 'Gáz - héra',
	remoteHeating: 'Távfűtés',
	remoteHeatingWithOwnMeasurer: 'Távfűtés egyedi mérővel',
	electric: 'Elektromos',
	houseCentralized: 'Házközponti',
	houseCentralizedWithUniqueMeter: 'Házközponti egyedi mérővel',
	geotermic: 'Geotermikus',
	gasAndAlternative: 'Gáz- alternatív',
	furnace: 'Kazán',
	stove: 'Kályha',
	fanCoil: 'Fan coil',
	otherHeating: 'Egyéb',
	nothing: 'Nincs',
	airHeating: 'Légfűtés',
	radiatorHeating: 'Radiátoros fűtés',
	floorHeating: 'Padlófűtés',
	wallHeating: 'Falfűtés',
	ceilingHeating: 'Mennyezetfűtés',
	HEATING: 'Fűtés',
	condition: 'Állapot',
	room: 'Szoba',
	halfRoom: 'Félszoba',
	kitchen: 'Konyha',
	livingroom: 'Nappali',
	bathroom: 'Fürdőszoba',
	bathroomWithToilet: 'Fürdőszoba WC-vel',
	toilet: 'WC',
	balcony: 'Erkély',
	caller: 'Hívó',
	service: 'Teher',
	none: 'Nincs',
	key: 'Kulcsos',
	closed: 'Zárt',
	circularCorridor: 'Körfolyosó',
	other: 'Egyéb',
	roomGarage: 'Teremgarázs / Garázs',
	closedPlace: 'Zárt kocsibeálló',
	openedPlace: 'Nyílt kocsibeálló',
	publicPayment: 'Közterületen fizetős',
	publicFree: 'közterületen ingyenes',
	noGarage: 'Nincs',
	true: 'Van',
	false: 'Nincs',
	uninhabitable: 'Nem beköltözhető',
	toRenew: 'Felújítandó',
	average: 'Átlagos',
	good: 'Jó',
	excellent: 'Felújított',
	newlyBuilt: 'Új építéseű',
	brick: 'Tégla',
	panel: 'Panel',
	shutter: 'Csúsztatott zsalus',
	wood: 'Fa',
	lightStructure: 'Könnyűszerkezet',
	adobe: 'Vályog',
	silicate: 'Szilikát',
	proconcept: 'Energiatakarékos',
	rockAndBrick: 'Kő és tégla',
	woodHouse: 'Rönkház',
	mixedMasonry: 'Vegyes falazat',
	passiveHouse: 'Passzívház',
	otherBuildingMaterial: 'Egyéb',
	diningroom: "Dining room",
	bad: 'Rossz',
	medium: 'Közepes',
	sunny: 'Napfényes',
	east: 'Keleti',
	southeast: 'Délkeleti',
	south: 'Déli',
	southwest: 'Délnyugati',
	west: 'Nyugati',
	northwest: 'Északnyugati',
	north: 'Északi',
	northeast: 'Északkeleti',
	street: 'Utcai',
	yard: 'Zöld udvar',
	garden: 'Kertre néző',
	panorama: 'Panoráma',
	withoutComfort: 'Komfort nélküli',
	halfComfort: 'Félkomfort',
	comfort: 'Komfort',
	fullComfort: 'Összkomfort',
	doubleComfort: 'Duplakomfort',
	luxurious: 'Luxus',
	pool: 'Medence',
	withGardenAccess: 'Kertkapcsolat',
	topFloor: 'Tetőtéri',
	navigationWithKeyboard: 'Navigálás billentyűzettel',
	prevPic: 'Előző kép',
	nextPic: 'Következő kép',
	thumbnails: 'Bélyegképek',
	zoom: 'Nagyítás',
	close: 'Bezárás',
	district: 'kerület',
	price: 'Ár',
	area: 'Alapterület',
	numOfRooms: 'Szobák száma',
	sqm: 'nm',
	half: 'fél',
	floor: 'Emelet',
	indoorHeight: 'Belmagasság',
	frenchBalcony: 'Francia erkély',
	terrace: 'Terasz',
	roofTerrace: 'Tetőterasz',
	loggia: 'Loggia',
	numberOfBathrooms: 'Fürdőszobák száma',
	saveSearch: 'Keresés mentése',
	saveSearchText: 'Kérjük nevezze el a menteni kívánt keresést',
	saveSearchLabel: 'Mentett keresés neve',
	bathroomAndToilet: 'Fürdőszoba és WC',
	lightCondition: 'Fényviszonyok',
	monthlyPrice: 'Rezsi közösköltséggel',
	separate: 'külön',
	common: 'egyben',
	separateAndCommon: 'külön és egyben is',

	/** advanced search */

	baseDatas: 'Alapadatok',
	size: 'Méret',
	convenience: 'Kényelem',
	extras: 'Extrák',
	gas: 'Gáz',
	buildingMaterial: 'Építési mód',
	countOfRooms: 'Szobák száma',
	elevator: 'Lift',
	hasElevator: 'Van lift',
	floorsOfTheBuilding: 'Épület szintjei',
	parking: 'Parkolás',
	balconyLabel: 'Erkély / terasz',
	view: 'Kilátás',
	stairwell: 'Lépcsőház',
	orientation: 'Tájolás',
	keyword: 'Kulcsszó',
	advancedSearch: 'Részletes keresés',
	propertyType: 'Ingatlan típusa',
	garageTitle: 'Kocsibeálló',
	showPhoneNumber: 'Mutasd',

	/** Összehasonlítás oldal címkék */

	location: 'Elhelyezkedés',
	roomCount: 'Szobaszám',

	/** */

	buildingYear: 'Építés éve',
	conditionOut: 'Épület külső állapota',
	conditionIn: 'Épület belső állapota',
	storageRoom: 'Tároló helyiség',

	/** átlagárak diagram */

	avgPricesTitle: 'Az ingatlan négyzetméter ára a környék átlagárához képest',
	avgPricesProperty: 'Ingatlan négyzetméter ára',
	avgPricesAround: 'Négyzetméter átlagárak a környéken',
	avgPriceDiagramTitle: 'Négyzetméter átlagárak változása a környéken',
	avgPricesMoreInfo: 'További árral kapcsolatos információk',

	/** Térkép */

	subway: 'Metró',
	bus: 'Busz',
	tram: 'Villamos',
	minute: 'perc',

	/** Megosztás */

	shareInEmail: 'Megosztás E-mailben',
	copyLink: 'Link másolása',

	/** Hasonló ingatlanok */

	similarTitle: 'Hasonló ingatlanok',
	projectTitle: 'Ingatlanok ebből a projektből',
	moreProjectLink: 'További ingatlanok ebből a projektből',

	/** Tanácsadó */

	agentTitle: 'Az Ön ingatlan tanácsadója:',
	refNumberText: 'Telefonos érdeklődés esetén kérjük hivatkozzon az alábbi referenciaszámra:',
	sendMessageButtonText: 'Üzenet küldése',

	/** Illeték */

	dutyTitle: 'Erre az ingatlanra fizetendő illeték:',
	dutyInfo: '*Az Illeték-kalkulátor csak tájékoztató jellegű és csak előzetes költségkalkulációs segédletnek tekintendő, mely nem hivatkozható semmilyen eljárásban és senkivel szemben.',

	/** Kalkulátor */

	loanTitle: 'Ismerje meg kedvező hitelajánlatainkat',
	loanPropertyPrice: 'Ingatlan vételára',
	loanErrorOnCalculation: 'Hiba a számolás közben',
	loanArp: 'THM',
	loanAmount: 'Hitelösszeg',
	loanTime: 'Futamidő',
	loanYear: 'Év',
	loanMonthlyPrice: 'Havi törlesztőrészlet',
	loanInterestedIn: 'Érdekel az ajánlat',
	loanMoreInfo: 'Tudjon meg többet hiteleinkről',

	webWalk: '3D Webséta'
};

export default translationsAADAT;
